import React, { Component } from "react";
import ReactDOM from "react-dom";



class ActuatorButton extends Component {
  constructor() {
    super();
    this.setActive = this.setActive.bind(this);
  }
  setActive() {
    this.props.onClick(this.props.actuator)
  }

  render(){
    
    return (
        <button 
        className="button-container button-actuator"
        onClick={this.setActive}>
          {this.props.actuator.name.replace("_", " ")}
        </button>
      );
  }
}

function Actuators(props){
    const user_actuators_names = props.user_actuators_names;

    let actuators = [];
    //produce an ordered list of actuators based on user actuator names
    let actuator_indexes = props.actuators.map((item => item.name));
    for(let user_actuator_name of user_actuators_names){
      let index = actuator_indexes.indexOf(user_actuator_name);
      if (index != -1){

        actuators.push(<ActuatorButton
          key={props.actuators[index].name}
          actuator={props.actuators[index]}
          onClick={props.setActiveActuator}
        />);
      }
    }
    let rows = [];
    let row = [];
    for(let i=0;i<actuators.length; i++){
      if (i%2 == 0){
        if(row.length > 0){
          rows.push(<div key={row + "-"+ i}className="actuators-row"> {row}</div>)
        }
        row = [];
      }
      row.push(<div key={i} className="actuator-menu-button">{actuators[i]} </div>)
    }
    if(row.length > 0){
      rows.push(<div key="last"  className="actuators-row"> {row}</div>)
    }
  
  
  
    return (
        <div className="actuators-menu">
          { rows }
        </div>
      );}

export default Actuators;
